import { Button, DataHeader, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAppointmentStatus extends Layout {
    buttonClearEvenColor: Button;
    buttonColorPicker: Button;
    labelAppointmentStatusColor: Label;
    panelAppointmentStatus: Panel;
    panelColorDisplay: Panel;
    panelColorSelector: Panel;
    panelDataHeader: DataHeader;
    sourceAppointmentStatus: DataSource;
    textAppointmentStatus: Textbox;
    textboxDescr: Textbox;
    textboxStatusColor: Textbox;
}
